import { Form as FormClass } from 'factorial-form'

class FormConfiguration extends FormClass {
  constructor(values: Record<string, unknown>) {
    super(values, {
      employee: 'string',
      accountingDate: 'string',
      receiverTin: 'string',
      receiverName: 'string',
      emitterTin: 'string',
      emitterName: 'string',
      invoiceType: 'string',
      number: 'string',
      currency: 'string',
      amount: 'cents',
      discountAmount: 'cents',
      irpfPercentage: 'string',
      equalizationTax: 'cents',
      documentDate: 'string',
    })
  }
}

export default FormConfiguration
